import { Link } from 'react-router-dom';

import { ROUTE_PM, ROUTE_KNM, ROUTE_DECISION } from 'CorePackage/MainModule/routes/routes';
import { ITableRenderCell } from 'CorePackage/TableModule/interfaces/ITableRenderCell';

import styles from './AgreementListRenderErpId.module.scss';

interface IKnmListErpId {
  passportId: string | number;
  passportType: string;
}

export function AgreementListErpIdCell<T extends IKnmListErpId>({ value, row, isTest }: ITableRenderCell<T>) {
  let link = `${ROUTE_DECISION(row.passportId)}#agreements`;

  if (row.passportType === 'PM') {
    link = `${ROUTE_PM(row.passportId)}#agreements`;
  }

  if (row.passportType === 'KNM') {
    link = `${ROUTE_KNM(row.passportId)}#agreements`;
  }

  return (
    <div className={styles.ErpIdCellWrapper}>
      <Link className="shared-table-link" to={link} target="_blank" rel="noopener noreferrer">
        {value}
      </Link>
      {isTest && <span className={styles.TestUserWrapper}>ТЕСТ</span>}
    </div>
  );
}
